import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { navLinks } from "@/mocks/forecast";

const today = new Intl.DateTimeFormat("zh-CN", {
  year: "numeric",
  month: "long",
  day: "numeric",
  weekday: "long",
}).format(new Date());

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const { pathname } = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative whitespace-nowrap px-1 py-2 text-sm font-medium transition-colors ${
      isActive ? "text-primary-600" : "text-foreground-700 hover:text-foreground-950"
    }`;

  return (
    <>
      <div className="hidden w-full bg-foreground-950 text-background-100 md:block">
        <div className="mx-auto flex max-w-[1280px] items-center justify-between px-4 py-2 text-xs md:px-6">
          <span className="flex items-center gap-2 text-background-300">
            <i className="ri-calendar-line" />
            {today}
          </span>
          <span className="flex items-center gap-4">
            <span className="flex items-center gap-2 text-background-300">
              <span className="relative flex h-2 w-2 items-center justify-center">
                <span className="absolute h-2 w-2 animate-ping rounded-full bg-accent-400" />
                <span className="h-2 w-2 rounded-full bg-accent-400" />
              </span>
              信号监测运行中
            </span>
            <span className="h-3 w-px bg-background-600" />
            <span className="text-background-300">
              <i className="ri-mail-line mr-1" />
              hello@kanliaodagua.example.com
            </span>
          </span>
        </div>
      </div>

      <header
        className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
          scrolled
            ? "border-background-200 bg-background-50/95 backdrop-blur"
            : "border-transparent bg-background-50/70 backdrop-blur"
        }`}
      >
        <div className="mx-auto flex h-16 w-full max-w-[1280px] items-center justify-between gap-6 px-4 md:h-20 md:px-6">
          <Link to="/" className="flex shrink-0 items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 font-heading text-xl font-bold text-background-50">
              瓜
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">看料大瓜</span>
              <span className="mt-1 text-[11px] tracking-[0.22em] text-foreground-500">预告前瞻 · 瓜田预警</span>
            </span>
          </Link>

          <nav className="hidden items-center gap-8 md:flex" aria-label="主导航">
            {navLinks.map((link) => (
              <NavLink key={link.to} to={link.to} className={linkClass} end={link.to === "/"}>
                {({ isActive }) => (
                  <>
                    {link.label}
                    {isActive && <span className="absolute -bottom-0.5 left-1 h-0.5 w-4 rounded-full bg-primary-500" />}
                  </>
                )}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <Link
              to="/#subscribe"
              className="hidden whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
            >
              蹲守提醒
            </Link>
            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
              aria-expanded={menuOpen}
              className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="border-t border-background-200 bg-background-50 md:hidden">
            <nav className="mx-auto flex max-w-[1280px] flex-col px-4 py-3" aria-label="移动端导航">
              {navLinks.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  end={link.to === "/"}
                  className={({ isActive }) =>
                    `flex items-center justify-between border-b border-background-200 py-3 text-base font-medium last:border-none ${
                      isActive ? "text-primary-600" : "text-foreground-800"
                    }`
                  }
                >
                  {link.label}
                  <i className="ri-arrow-right-s-line text-foreground-400" />
                </NavLink>
              ))}
              <Link
                to="/#subscribe"
                className="mt-4 mb-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-center text-sm font-semibold text-background-50"
              >
                订阅蹲守提醒
              </Link>
            </nav>
          </div>
        )}
      </header>
    </>
  );
}